export default function setupWobbleGui({ gui, wobble, label = 'Wobble' })
{
  const folder = gui.addFolder(label)

  folder.close()

  // Wobble params
  folder.add(wobble.uniforms.uPositionFrequency, 'value', 0, 2, 0.001).name('Position Frequency')
  folder.add(wobble.uniforms.uTimeFrequency, 'value', 0, 2, 0.001).name('Time Frequency')
  folder.add(wobble.uniforms.uStrength, 'value', 0, 2, 0.001).name('Strength')

  folder.add(wobble.uniforms.uWarpPositionFrequency, 'value', 0, 2, 0.001).name('Warp Pos Freq')
  folder.add(wobble.uniforms.uWarpTimeFrequency, 'value', 0, 2, 0.001).name('Warp Time Freq')
  folder.add(wobble.uniforms.uWarpStrength, 'value', 0, 2, 0.001).name('Warp Strength')

  // Colors
  folder.addColor(wobble.debugObject, 'colorA').name('colorA').onChange((v) =>
  {
    wobble.setColors(v, null)
  })

  folder.addColor(wobble.debugObject, 'colorB').name('colorB').onChange((v) =>
  {
    wobble.setColors(null, v)
  })
}
